import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-policy-page">
      {/* Hero Section */}
      <section className="py-16 bg-[#0F172A]">
        <div className="container-custom">
          <h1 className="heading-h1 text-white">PRIVACY POLICY</h1>
          <p className="text-slate-400 mt-4">Last updated: December 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-light">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto policy-content">
            <p className="text-body mb-8">
              Cart Genix ("we," "our," or "us") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your 
              information when you visit our website or use our services.
            </p>

            <h2>Information We Collect</h2>
            <p>We may collect information about you in various ways, including:</p>
            <ul>
              <li><strong>Personal Data:</strong> Name, email address, phone number, and mailing address when you fill out our contact forms or request services.</li>
              <li><strong>Service Information:</strong> Details about your roofing needs, property information, and service history.</li>
              <li><strong>Usage Data:</strong> Information about how you use our website, including IP address, browser type, and pages visited.</li>
              <li><strong>Cookies:</strong> We use cookies to enhance your browsing experience and analyze website traffic.</li>
            </ul>

            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, maintain, and improve our roofing services</li>
              <li>Respond to your inquiries and service requests</li>
              <li>Send you quotes, estimates, and service-related communications</li>
              <li>Send marketing and promotional materials (with your consent)</li>
              <li>Analyze usage patterns to improve our website</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2>Information Sharing</h2>
            <p>We do not sell your personal information. We may share your information with:</p>
            <ul>
              <li><strong>Service Providers:</strong> Third parties who assist us in operating our website and providing services</li>
              <li><strong>Business Partners:</strong> Material suppliers and subcontractors when necessary to complete your project</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
            </ul>

            <h2>Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information. 
              However, no method of transmission over the Internet is 100% secure, and we cannot 
              guarantee absolute security.
            </p>

            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt out of marketing communications</li>
              <li>Withdraw consent at any time</li>
            </ul>

            <h2>California Privacy Rights</h2>
            <p>
              California residents have additional rights under the California Consumer Privacy Act (CCPA), 
              including the right to know what personal information is collected and the right to request deletion.
            </p>

            <h2>Children's Privacy</h2>
            <p>
              Our services are not directed to individuals under 18. We do not knowingly collect 
              personal information from children.
            </p>

            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes 
              by posting the new policy on this page and updating the "Last updated" date.
            </p>

            <h2>Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us:</p>
            <ul>
              <li><strong>Email:</strong> support@cartgenix.store</li>
              <li><strong>Phone:</strong> +1-888-445-1244</li>
              <li><strong>Address:</strong> 998 Sunset Boulevard, Los Angeles, CA 80021</li>
            </ul>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <Link to="/" className="text-[#F97316] font-semibold hover:underline">
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
